//Backside of the jobsite card, shown if the worker is a foreman. 
import React, { useState } from "react";
import KyoskModal from "./KyoskModal";
import ForemanAddWorkerModal from "./ForemanAddWorkerModal";

const ForemanJobsiteCard = ({ jobSite, onBackClick }) => {
  const [showKyoskModal, setShowKyoskModal] = useState(false);
  const [showAddWorkerModal, setShowAddWorkerModal] = useState(false);

  return (
    <div className="p-4 rounded-lg bg-white">
      <div className="relative flex items-center mb-4 h-8">
        <button
          onClick={onBackClick}
          className="text-sm text-charcoal flex items-center z-10"
        >
          {/* Back Arrow SVG */}
          <svg className="w-5 h-5 mr-1 text-orangem" fill="none" stroke="currentColor" strokeWidth="2" viewBox="0 0 24 24">
            <path strokeLinecap="round" strokeLinejoin="round" d="M15 19l-7-7 7-7" />
          </svg>
        </button>
        <h2 className="absolute left-1/2 top-1/2 transform -translate-x-1/2 -translate-y-1/2 text-xl font-kanit m-0">
          {jobSite.jobsiteName}
        </h2>
      </div>
      <div className="flex flex-col gap-4">
        <button
          className="bg-teal text-white rounded-lg py-2"
          onClick={() => setShowKyoskModal(true)}
        >
          Kyosk
        </button>
        {/* <button className="bg-teal text-white rounded-lg py-2">Ticket Workers</button>
        <button className="bg-teal text-white rounded-lg py-2">Today's List</button> */}
        <button className="bg-teal text-white rounded-lg py-2" onClick={() => setShowAddWorkerModal(true)}>
          Send Invitation
        </button>
      </div>
      {showKyoskModal && (
        <KyoskModal onClose={() => setShowKyoskModal(false)} jobsiteId={jobSite.id} />
      )}
      {showAddWorkerModal && (
        <div className="fixed inset-0 z-50 flex items-center justify-center bg-black bg-opacity-40">
          <div className="bg-white rounded-lg shadow-lg p-4 relative max-w-lg w-full">
            <ForemanAddWorkerModal onClose={() => setShowAddWorkerModal(false)} />
          </div>
        </div>
      )}
    </div>
  );
};

export default ForemanJobsiteCard;